import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';

type NuqsProviderProps = {
  children: React.ReactNode;
};

export const NuqsProvider = (props: NuqsProviderProps) => {
  const { children } = props;

  return <NuqsAdapter>{children}</NuqsAdapter>;
};
